<div
  class="flex max-w-[900px] items-center text-lg text-black"
  [ngClass]="{
    border: withBorder() && size() === 'small',
    'border-2': withBorder() && size() === 'big',
    'border-red-error bg-warning-50': type() === types.Error,
    'border-orange-warning bg-warning-100': type() === types.Warning,
    'border-blue-primary bg-blue-light': type() === types.Info,
    'border-green-success bg-green-mid': type() === types.Success,
    'w-full gap-4 rounded-xl p-8 text-sm font-semibold': size() === 'big',
    'w-fit gap-0.5 rounded-lg px-2 py-0 text-xs font-light': size() === 'small',
  }"
>
  @switch (type()) {
    @case (types.Success) {
      <img
        priority="true"
        alt="Success Icon"
        width="40"
        height="40"
        [ngSrc]="'/assets/icons/ic_diamond.svg'"
      />
    }
    @case (types.Error) {
      <img
        priority="true"
        alt="Warning Icon"
        width="40"
        height="40"
        [ngSrc]="'/assets/icons/ic_warning_fire.svg'"
      />
    }
    @default {
      <mat-icon
        [ngClass]="{
          'min-h-10 min-w-9': size() === 'big',
          'text-red-error': type() === types.Error,
          'text-orange-warning': type() === types.Warning,
          'text-green-success': type() === types.Success,
          'text-blue-primary': type() === types.Info,
          '-mr-1 mt-1 text-sm': size() === 'small',
        }"
      >
        warning_amber
      </mat-icon>
    }
  }
  <span class="flex flex-col gap-2">
    {{ text() }}
    @if (size() === "big" && subText()) {
      <span class="text-sm font-thin">{{ subText() }}</span>
    }
  </span>
</div>
